class ScrollHint extends HTMLElement {
    connectedCallback() {
      this.addEventListener('scroll', this.#update);
      this.#resizeObserver.observe(this);
    }
  
    disconnectedCallback() {
      this.removeEventListener('scroll', this.#update);
      this.#resizeObserver.disconnect();
    }
  
    #update = () => {
      const { scrollTop, scrollHeight, clientHeight, scrollLeft, scrollWidth, clientWidth } = this;
      const scrollDirection = scrollWidth > clientWidth ? 'horizontal' : 'vertical';
      const scrollPercentage =
        scrollDirection === 'vertical'
          ? scrollTop / (scrollHeight - clientHeight)
          : scrollLeft / (scrollWidth - clientWidth);
  
      this.style.maskImage = Number.isNaN(scrollPercentage)
        ? ''
        : `linear-gradient(
          to ${scrollDirection === 'vertical' ? 'bottom' : 'right'},
          transparent ${scrollPercentage > 0 ? 1 : 0}%,
          black ${scrollPercentage < 0.1 ? scrollPercentage * 100 : 10}%,
          black ${scrollPercentage > 0.9 ? scrollPercentage * 100 : 90}%,
          transparent 100%
        )`;
    };
  
    #resizeObserver = new ResizeObserver(this.#update);
  }
  if (!customElements.get('scroll-hint')) {
    customElements.define('scroll-hint', ScrollHint);
  }